import { render, staticRenderFns } from "./ModalDeleteAsset.vue?vue&type=template&id=5fcbc74a"
import script from "./ModalDeleteAsset.vue?vue&type=script&lang=js"
export * from "./ModalDeleteAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports